// import video from "../assets/slider.mp4";
import { useTranslation } from "react-i18next";
import Collage2 from "../assets/slider.jpg";

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about_Section" >
      <div className="introVideoContainer">
        {/* <video src={video} autoPlay loop muted></video> */}
          <img src={Collage2} className="collageImg" alt="" />
      </div>
      <div className="text2" id="about">
        {t("about_title")}
      </div>
      <div className="introduction">
        <div className="text3">
          <p>{t("about_para1")}</p>
          <p>{t("about_para2")}</p>
          <p>{t("about_para3")}</p>
          <p>{t("about_para4")}</p>
          {/* <p>{t("about_para5")}</p> */}

        </div>
      </div>

    </div>
  );
};

export default About;










// import { useTranslation } from "react-i18next";
// import Collage2 from "../assets/slider.jpg";
// import "./About.css";

// const About = () => {
//   const { t } = useTranslation();

//   return (
//     <section className="ld-about" id="about">
//       {/* Hero image */}
//       <div className="ld-about-hero">
//         <img
//           src={Collage2}
//           alt="The flavours and atmosphere of Listen to Delhi"
//           className="ld-about-hero-image"
//         />

//         <div className="ld-about-hero-overlay" />

//         <div className="ld-about-hero-content">
//           <span className="ld-about-eyebrow">
//             LISTEN TO DELHI · OSLO
//           </span>

//           <h1>{t("about_title")}</h1>

//           <span className="ld-about-hero-line" />
//         </div>
//       </div>

//       <div className="ld-about-intro">
//         <div className="ld-about-heading">
//           <span className="ld-about-label">
//             OUR STORY
//           </span>

//           <h2>
//             Bringing the Spirit of
//             <br />
//             <em>Delhi to Oslo</em>
//           </h2>

//           <div className="ld-about-divider">
//             <span />
//             <span className="ld-about-flower">✳</span>
//             <span />
//           </div>
//         </div>

//         <div className="ld-about-description">
//           <p>{t("about_para1")}</p>
//           <p>{t("about_para2")}</p>
//           <p>{t("about_para3")}</p>
//           <p>{t("about_para4")}</p>
//         </div>
//       </div>

//       <div className="ld-about-footer">
//         <span className="ld-about-footer-line" />
//         <p>
//           AUTHENTIC FLAVOURS <span>✳</span> MADE WITH PASSION
//         </p>
//         <span className="ld-about-footer-line" />
//       </div>
//     </section>
//   );
// };

// export default About;

